'use strict';

exports.__esModule = true;
exports.carousel = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _carouselActions = require('../actions/carousel-actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
	selectedSpecialist: {
		name: 'all',
		id: 'all'
	},
	practiceReviewsOffset: 0,
	specialistsReviewsOffset: 0,
	specialistReviewsOffset: 0,
	specialistRecommendationsOffset: 0,
	specialistsRecommendationsOffset: 0
};

var carousel = exports.carousel = function carousel(state, action) {
	switch (action.type) {
		case _carouselActions.SELECT_SPECIALIST:
			return (0, _extends3.default)({}, state, {
				selectedSpecialist: action.specialist
			});
		case _carouselActions.SET_FILTER:
			return (0, _extends3.default)({}, state, {
				filter: action.filter
			});
		case _carouselActions.UPDATE_OFFSET:
			return (0, _extends3.default)({}, state, action.offset);
		default:
			return state || INITIAL_STATE;
	}
};